import {makeAutoObservable} from 'mobx';

class SessionStore {
    type = null;
    isAuthenticated = false;
    isTimedOut = false

    constructor() {
        makeAutoObservable(this);
    }

    onHandleAuthenticateUser = (type, isAuthenticated) => {
        this.type = type;
        this.isAuthenticated = isAuthenticated;
    };

    handleLogoutUser(isTimedOut) {
        this.isTimedOut = isTimedOut;
    }
}

const sessionStore = new SessionStore();

export default sessionStore;
